/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */


export const DUMMY_IMAGE = require("./res/images/300-300.webp");
export const ORDINARY_DAY_IMAGE = require("./res/images/ordinary-day.webp");

export const GOLD_ICON = require('./res/images/gold.webp');
export const PLATINUM_ICON = require('./res/images/platinum-1.webp');
export const DIAMOND_ICON = require('./res/images/diamond.webp');


export const LOADING_IMAGE = require('./res/images/loading-img.webp');


export const EMPTY_IMAGE = require('./res/images/empty.webp');
export const SOUND = require('./res/images/sound.png');
export const VIDEO =require('./res/images/default-video.webp');
export const musicButton =  require('./res/images/music-button.png');
export const videoButton =  require('./res/images/video-button.png');
export const button3D =  require('./res/images/3d-button.webp');


export const NO_ASSET = require('./res/images/no-asset.webp');

export const CREATED = require('./res/images/create.webp');
export const LISTED = require('./res/images/listing.png');
export const MINTED = require('./res/images/minted.png');
export const ANCHOR = require('./res/images/anchor.webp');

export const PLT_LOGO = require('./res/images/pltlogo.webp');
export const PLT_LOGO_WHITE = require('./res/images/pltlogo-white.webp');
export const ETHER = require("./res/images/ether.webp");
export const MATIC = require("./res/images/matic.webp");


export const BANNER_IMAGE = require('./res/images/bg.webp');
export const VANTR_ILLUSTRATION_IMAGE = require('./res/images/vantr-illustration.webp');

export const IMAGES = [
    DUMMY_IMAGE,
    ORDINARY_DAY_IMAGE,

    GOLD_ICON,
    PLATINUM_ICON,
    DIAMOND_ICON,
    
    LOADING_IMAGE,
    EMPTY_IMAGE,
    NO_ASSET,

    CREATED,
    LISTED,
    MINTED,
    ANCHOR,

    PLT_LOGO,
    ETHER,
    MATIC
];
